export function loadApproperiateImage(originalUrl: string | undefined, newSegment: string) {
  if (!originalUrl?.includes('imagedelivery.net')) return originalUrl || '';

  try {
    const urlObject = new URL(originalUrl);
    const pathSegments = urlObject.pathname.split('/').filter(Boolean);

    if (pathSegments.length > 0) {
      pathSegments[pathSegments.length - 1] = newSegment;
    }

    urlObject.pathname = pathSegments.join('/');
    return urlObject.toString();
  } catch (error) {
    console.error('Error updating URL:', error);
    return originalUrl || '';
  }
}

export function nextImageWrapper(url: string | URL, w?: number) {
  return `/_next/image?url=${encodeURI(url.toString())}&w=${w || 3840}&q=100`;
}
